import React, { useCallback } from 'react';
import { CollapsibleList } from 'taboola-ultimate-ui';
import CONVERSION_RULE_MODES from '../../../config/ConversionRuleModes';
import { ConversionRulesDropDown } from '../ConversionRulesDropDown/ConversionRulesDropDown';
import { CampaignConversionRuleItem } from './CampaignConversionRuleItem';
import styles from './campaignConversionRules.module.scss';

export const CampaignConversionRules = ({
    conversionRules,
    onChangeConversionRules,
    setHasOptions,
    disabled,
    onChangeConversionRuleMode,
    disabledConversionRules,
    message,
    fieldName,
    isOtherConversionRules,
}) => {
    const deleteItem = useCallback(
        ({ id: idToDelete }) => {
            if (conversionRules.length === 1 && !isOtherConversionRules) {
                onChangeConversionRuleMode(CONVERSION_RULE_MODES.DEFAULT);
            }
            onChangeConversionRules(prev => prev.filter(val => val.id !== idToDelete));
        },
        [conversionRules.length, onChangeConversionRuleMode, onChangeConversionRules, isOtherConversionRules]
    );

    const clearItems = useCallback(() => {
        onChangeConversionRules([]);
    }, [onChangeConversionRules]);

    return (
        <div>
            <ConversionRulesDropDown
                setHasOptions={setHasOptions}
                disabled={disabled}
                disabledConversionRules={disabledConversionRules}
                message={message}
                fieldName={fieldName}
            />
            {conversionRules && !disabled && (
                <CollapsibleList
                    items={conversionRules}
                    containerClassName={styles['conversions-list']}
                    data-automation="conversion-collapsible-list"
                    ItemComponent={CampaignConversionRuleItem}
                    metadata={{ totalItems: conversionRules?.length }}
                    deleteItem={deleteItem}
                    clearItems={clearItems}
                />
            )}
        </div>
    );
};
